/** The warehouse's own fields, and the two actions on the record. */
import { Loader2, Save, Trash2 } from 'lucide-react';

import type { WarehouseFormData } from '../useWarehouseRecord';

const LABEL = 'block text-sm font-medium text-bark-900 dark:text-stone-100 mb-1';
const FIELD =
  'w-full px-3 py-2 border rounded-lg bg-white dark:bg-[#242d28] text-bark-900 dark:text-stone-100';

export default function WarehouseBasicInfoForm({
  formData,
  setFormData,
  saving,
  onSave,
  onDeactivate,
}: {
  formData: WarehouseFormData;
  setFormData: (next: (prev: WarehouseFormData) => WarehouseFormData) => void;
  saving: boolean;
  onSave: () => void;
  onDeactivate: () => void;
}) {
  return (
    <div className="space-y-4">
      <div>
        <label className={LABEL}>Name</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData((p) => ({ ...p, name: e.target.value }))}
          disabled={saving}
          className={FIELD}
        />
      </div>
      <div>
        <label className={LABEL}>Code</label>
        <input
          type="text"
          value={formData.code}
          onChange={(e) => setFormData((p) => ({ ...p, code: e.target.value }))}
          disabled={saving}
          className={FIELD}
        />
      </div>
      <div>
        <label className={LABEL}>Description</label>
        <textarea
          value={formData.description}
          onChange={(e) => setFormData((p) => ({ ...p, description: e.target.value }))}
          disabled={saving}
          rows={3}
          className={`${FIELD} resize-none`}
        />
      </div>
      <div className="flex gap-3">
        <button
          onClick={onSave}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2 bg-moss-600 text-white rounded-lg hover:bg-moss-700 transition disabled:opacity-50"
        >
          {saving && <Loader2 size={14} className="animate-spin" />}
          <Save size={14} />
          Save
        </button>
        <button
          onClick={onDeactivate}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition disabled:opacity-50"
        >
          <Trash2 size={14} />
          Deactivate
        </button>
      </div>
    </div>
  );
}
